import { Component, NgZone, OnInit } from '@angular/core';
import { SatisfactionService } from '../../../services/Satisfaction/satisfaction.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dataviz from "@amcharts/amcharts4/themes/dataviz";

@Component({
  selector: 'app-satisfaction-management',
  templateUrl: './satisfaction-management.component.html',
  styleUrls: ['./satisfaction-management.component.scss']
})
export class SatisfactionManagementComponent implements OnInit {

  constructor(
    private SatisfactionService: SatisfactionService,
    private zone: NgZone
  ) { }

  items = [];
  pageOfItems: Array<any>;
  satisfaction_data: any;
  count: any;
  count_1_star: number = 0;
  count_2_star: number = 0;
  count_3_star: number = 0;
  count_4_star: number = 0;
  count_5_star: number = 0;
  size: any;

  ngOnInit(): void {
    this.get_Satisfaction_score();
    this.get_Satisfaction_comment()
  }

  get_Satisfaction_score() {
    this.SatisfactionService.Get_Satisfaction().subscribe(
      responce => {

        // this.items = Array(responce.length).fill(0).map((x, i) => ({
        //   number: i + 1,
        //   id: responce[i].id,
        //   score: responce[i].score
        // }));
        this.size = responce.length;
        this.ngAfterViewInit(responce);
      }
    )
  }

  get_Satisfaction_comment(){
    this.SatisfactionService.Get_Satisfaction_Comment().subscribe(
      response => {
        this.items = Array(response.length).fill(0).map((x, i) => ({
          number: i + 1,
          id: response[i].id,
          commect: response[i].commect,
          ipUser: response[i].ipUser
        }));
        this.count = response.length;
      }
    );
  }

  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  ngAfterViewInit(data4chart) {
    let data = [];
    let one_star = 0;
    let two_star = 0;
    let three_star = 0;
    let four_star = 0;
    let five_star = 0;
    for (let i = 0; i < this.size; i++) {
      if (data4chart[i].titleTypeId == 1) {
        one_star += data4chart[i].score;
      } else if (data4chart[i].titleTypeId == 2) {
        two_star += data4chart[i].score;
      } else if (data4chart[i].titleTypeId == 3) {
        three_star += data4chart[i].score;
      } else if (data4chart[i].titleTypeId == 4) {
        four_star += data4chart[i].score;
      } else if (data4chart[i].titleTypeId == 5) {
        five_star += data4chart[i].score;
      }
    }

    //กราฟ
    this.zone.runOutsideAngular(() => {
      am4core.useTheme(am4themes_animated);

      let chart = am4core.create("chartdiv_Standard", am4charts.PieChart);
      chart.hiddenState.properties.opacity = 0;

        data.push(
          {
            "level": "ด้านเนื้อหา ",
            "value": one_star,
            "color": am4core.color("#ca0000")
          },
          {
            "level": "ด้านการออกแบบและการจัดรูปแบบเว็ปไซต์ ",
            "value": two_star,
            "color": am4core.color("#ff8000")
          },
          {
            "level": "ด้านประโยชน์และการนำไปใช้งาน ",
            "value": three_star,
            "color": am4core.color("#fff300")
          },
          {
            "level": "ด้านความถูกต้องและครบถ้วนของข้อมูล ",
            "value": four_star,
            "color": am4core.color("#00ff70")
          }
        )

      let title = chart.titles.create();
      title.fontSize = "20px";
      title.text = "ความพึงพอใจ";
      title.disabled = false;

      chart.data = data;
      chart.logo.disabled = true;
      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.filePrefix = "มาตรฐานสหกรณ์";
      chart.exporting.useWebFonts = false;
      chart.exporting.validateSprites.push(title);
      chart.exporting.validateSprites.push(title.parent);

      var series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = "value";
      series.dataFields.category = "level";
      series.slices.template.propertyFields.fill = "color";
      series.slices.template.propertyFields.stroke = "color";

      series.slices.template.cornerRadius = 10;
      series.slices.template.innerCornerRadius = 8;
      series.slices.template.inert = true;
      series.alignLabels = false;

      series.hiddenState.properties.startAngle = 90;
      series.hiddenState.properties.endAngle = 90;


      // เปลี่ยนเปอร์เซ็นต์เป็นตัวเลข
      series.calculatePercent = true;
      series.labels.template.text = "{category}: {value.value}";
      series.slices.template.tooltipText = "{category}: {value.value}";

      chart.legend = new am4charts.Legend();
    })

  }


  ngOnDestroy() {
    // Clean up chart when the component is removed

    this.zone.runOutsideAngular(() => {

      am4core.disposeAllCharts();

    });
  }

}
